import { render, staticRenderFns } from "./book.vue?vue&type=template&id=b1b64844&scoped=true&"
import script from "./book.vue?vue&type=script&lang=js&"
export * from "./book.vue?vue&type=script&lang=js&"
import style0 from "./book.vue?vue&type=style&index=0&id=b1b64844&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b64844",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b64844')) {
      api.createRecord('b1b64844', component.options)
    } else {
      api.reload('b1b64844', component.options)
    }
    module.hot.accept("./book.vue?vue&type=template&id=b1b64844&scoped=true&", function () {
      api.rerender('b1b64844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/specialty/book.vue"
export default component.exports